import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Paper, Typography, Button, Chip } from '@mui/material';
import { DataGrid, type GridColDef } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import { useSolicitudCompraStore } from '../store/solicitudCompraStore';

const estadoColors: Record<string, 'success' | 'warning' | 'error' | 'default'> = {
  APR: 'success', PEN: 'warning', ANU: 'error',
};
const estadoLabels: Record<string, string> = {
  APR: 'Aprobada', PEN: 'Pendiente', ANU: 'Anulada',
};

export const SolicitudesCompraPage: React.FC = () => {
  const navigate = useNavigate();
  const { items, loading, fetchAll } = useSolicitudCompraStore();

  useEffect(() => { fetchAll(); }, [fetchAll]);

  const columns: GridColDef[] = [
    { field: 'numero', headerName: 'Numero', width: 120 },
    {
      field: 'fechaSolicitud', headerName: 'Fecha', width: 120,
      valueFormatter: (value: string) => {
        try { return format(new Date(value), 'dd/MM/yyyy', { locale: es }); } catch { return value; }
      },
    },
    { field: 'proveedor', headerName: 'Proveedor', flex: 1, minWidth: 200, valueGetter: (value: any) => value?.razonSocial || '-' },
    {
      field: 'total', headerName: 'Total', width: 120, type: 'number',
      valueFormatter: (value: number) => `S/ ${(value ?? 0).toFixed(2)}`,
    },
    {
      field: 'estado', headerName: 'Estado', width: 120,
      renderCell: (params) => (
        <Chip label={estadoLabels[params.value] || params.value || '-'} color={estadoColors[params.value] || 'default'} size="small" />
      ),
    },
  ];

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h5" fontWeight="bold">Solicitudes de Compra</Typography>
        <Button variant="contained" startIcon={<AddIcon />} onClick={() => navigate('/compras/solicitud-compra/nueva')}>
          Nueva Solicitud
        </Button>
      </Box>
      <Paper sx={{ height: 600 }}>
        <DataGrid
          rows={items} columns={columns} getRowId={(row) => row.idSolicitudCompra}
          loading={loading} pageSizeOptions={[10, 20, 50]}
          initialState={{ pagination: { paginationModel: { pageSize: 20 } } }}
          onRowClick={(params) => navigate(`/compras/solicitud-compra/${params.row.idSolicitudCompra}`)}
          sx={{ cursor: 'pointer', border: 'none' }} disableRowSelectionOnClick
        />
      </Paper>
    </Box>
  );
};
